import { DOCUMENT_TYPES } from 'utils/constants/documentTypes';

export const DOCUMENT_STATUS_ORDER: { [key in DOCUMENT_TYPES]?: any } = {
  [DOCUMENT_TYPES.ACCESSIBILITY_COMPLIANCE]: [
    'Project Registered',
    'Review Complete',
    'Inspection Complete',
    'Project Closed',
  ],
};

/**
 * Sorts an array in place by a reference array.
 * @param list The array of items to be sorted
 * @param keyFunc A function that selects the key from an individual item in list
 * @param referenceOrder An array of strings to reference the order from
 */
export const sortByReference = (
  list: any[],
  keyFunc: (item: any) => string,
  referenceOrder: string[],
) => {
  return list.sort((a, b) => {
    const indexA = referenceOrder.indexOf(keyFunc(a));
    const indexB = referenceOrder.indexOf(keyFunc(b));

    // If one label is not in the reference list, place its item at the end
    if (indexA === -1) {
      return 1;
    }
    if (indexB === -1) {
      return -1;
    }

    // If both labels are in the reference list, order their items by the labels' positions in the reference list
    return indexA - indexB;
  });
};
